import ReactMarkdown from 'react-markdown'
import { getCurrentTosEffectiveDate } from 'lib/helpers/getCurrentTosEffectiveDate/getCurrentTosEffectiveDate'
import ToSText2025_01_20 from 'md/terms-of-service/terms-of-service-2025-01-20.md'
import ToSText2026_03_19 from 'md/terms-of-service/terms-of-service-2026-03-19.md'

export const TermsOfServiceMarkdown = () => {
  const currentTosEffectiveDate = getCurrentTosEffectiveDate()

  if (currentTosEffectiveDate === '2026-03-19') {
    return <ReactMarkdown>{ToSText2026_03_19}</ReactMarkdown>
  }

  return <ReactMarkdown>{ToSText2025_01_20}</ReactMarkdown>
}
